import { render, staticRenderFns } from "./DocumentUploadButton.vue?vue&type=template&id=7ea34f62"
import script from "./DocumentUploadButton.vue?vue&type=script&lang=js"
export * from "./DocumentUploadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports